<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [columns]="columns"
  (cancelChange)="cancel()"
  (submitChange)="save()"
  [isShowModal]="false">
  <ng-container class="content" *ngIf="itemColumns && itemColumns.length > 0">
    <div class="pagebox">
      <ssg-select
        name="BranchId"
        [group]="formGroup"
        [dataList]="BranchLookUp"
        [label]="'ClientApp.FrontOffice.Inv.DailyRemain.Branch' | translate"
        textFieldName="Title"
        valueFieldName="Id"
        userClass="select-sm">
      </ssg-select>
      <date-picker
        id="VoucherDate"
        name="VoucherDate"
        [label]="'ClientApp.FrontOffice.Inv.DailyRemain.TransitionFromHistory' | translate"
        [group]="formGroup"
        userClass="select-sm"
        required="false"
        textType="date"
        disabled="false">
      </date-picker>
      <ssg-input
        [group]="formGroup"
        userClass="select-sm"
        name="Description"
        textType="text"
        [label]="'ClientApp.FrontOffice.Inv.DailyRemain.Description' | translate"></ssg-input>
    </div>

    <editable-grid
      #grid
      [columns]="itemColumns"
      [dataList]="model.InvDailyRemainDetaillList"
      (formGroupValueChanges)="onGridValueChanges($event)"
      [isAdd]="false"
      [RowNumberName]="'RowNumber'"
      (onRowSelected)="onRowSelected()"
      (afterDeleted)="afterDeleted()"
      [filtering]="true"
      [paging]="true">
      <ssg-button
        *ngIf="!currentrow"
        id="toolbar-button"
        class="load-icon"
        (click)="loadItems()"
        [tooltip]="'ClientApp.FrontOffice.Inv.DailyRemain.Upload' | translate"
        icon="icon-upload"></ssg-button>
      <ssg-button
        id="toolbar-button"
        class="load-icon"
        (click)="removeEmptyValues()"
        [tooltip]="'ClientApp.FrontOffice.Inv.DailyRemain.RemoveItemsWithoutValue' | translate"
        icon="icon-cancel-F"></ssg-button>
    </editable-grid>
  </ng-container>
</dynamic-form>
